import { createLogic } from 'redux-logic'
import { map } from 'rxjs/operators'
import * as constants from '../constants'

export const getCompsOffices = createLogic({
  type: constants.GET_OFFICES.ACTION,
  processOptions: {
    successType: constants.GET_OFFICES.FULFILLED,
    failType: constants.GET_OFFICES.REJECTED
  },

  process({ http }) {

  return http
      .get('/comps/offices')
      .pipe(
        map(http.getBody),
        map(res => (
          { regions: res }
        ))
      )
  }
})
